const VISIBLE_RANGE = 2; // páginas a mostrar a cada lado de la actual

const App = (props) => {
  const paginas = props.paginas || [];
  const total = paginas.length;

  if (total === 0) return null;

  const currentLabel = props.paginaActual ? props.paginaActual.label : 1;
  let currentIndex = paginas.findIndex((p) => p.label === currentLabel);
  if (currentIndex === -1) currentIndex = 0;

  const goTo = (row) => {
    if (row) props.setPaginaActual(row);
  };

  let start = Math.max(0, currentIndex - VISIBLE_RANGE);
  let end = Math.min(total - 1, currentIndex + VISIBLE_RANGE);

  const windowSize = VISIBLE_RANGE * 2;
  if (end - start < windowSize) {
    if (start === 0) end = Math.min(total - 1, start + windowSize);
    if (end === total - 1) start = Math.max(0, end - windowSize);
  }

  const visiblePages = paginas.slice(start, end + 1);
  const isFirst = currentIndex <= 0;
  const isLast = currentIndex >= total - 1;

  return (
    <>
      <div className="d-flex flex-row-reverse">
        <nav aria-label="Programandoweb, siempre lo hacemos bien">
          <ul className="pagination flex-wrap align-items-center mb-0">
            <li className={"page-item" + (isFirst ? " disabled" : "")}>
              <a
                className="page-link mr-1"
                href="#first"
                onClick={(e) => { e.preventDefault(); if (!isFirst) goTo(paginas[0]); }}
              >
                «
              </a>
            </li>
            <li className={"page-item" + (isFirst ? " disabled" : "")}>
              <a
                className="page-link mr-1"
                href="#prev"
                onClick={(e) => { e.preventDefault(); if (!isFirst) goTo(paginas[currentIndex - 1]); }}
              >
                ‹
              </a>
            </li>

            {start > 0 && (
              <>
                <li className="page-item" onClick={() => goTo(paginas[0])}>
                  <a className="page-link mr-1" href={"#" + paginas[0].label}>{paginas[0].label}</a>
                </li>
                {start > 1 && (
                  <li className="page-item disabled">
                    <span className="page-link mr-1">…</span>
                  </li>
                )}
              </>
            )}

            {visiblePages.map((row, key) => {
              const isActive = row.label === currentLabel;
              return (
                <li key={key} className={isActive ? "page-item active" : "page-item"} onClick={() => goTo(row)}>
                  <a className="page-link mr-1" href={"#" + row.label}>{row.label}</a>
                </li>
              );
            })}

            {end < total - 1 && (
              <>
                {end < total - 2 && (
                  <li className="page-item disabled">
                    <span className="page-link mr-1">…</span>
                  </li>
                )}
                <li className="page-item" onClick={() => goTo(paginas[total - 1])}>
                  <a className="page-link mr-1" href={"#" + paginas[total - 1].label}>{paginas[total - 1].label}</a>
                </li>
              </>
            )}

            <li className={"page-item" + (isLast ? " disabled" : "")}>
              <a
                className="page-link mr-1"
                href="#next"
                onClick={(e) => { e.preventDefault(); if (!isLast) goTo(paginas[currentIndex + 1]); }}
              >
                ›
              </a>
            </li>
            <li className={"page-item" + (isLast ? " disabled" : "")}>
              <a
                className="page-link mr-1"
                href="#last"
                onClick={(e) => { e.preventDefault(); if (!isLast) goTo(paginas[total - 1]); }}
              >
                »
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </>
  );
};

export default App;
